import Product from "Entity/Product";

const mergeStickerProductResponse = (product: Product, responseProduct: Product): Product => {
    return {
        ...product,
        stickers: responseProduct.stickers ?? product.stickers,
    }
}

export default mergeStickerProductResponse
